/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Chinese (Traditional)
export default {
  'ai-mate.chat-error-banner.description': '您的聊天記錄最多可儲存 30 天。',
  'ai-mate.chat-error-banner.title': '開始新聊天',
  'ai-mate.chat-error.description': '嘗試<btn>重新載入聊天</btn>。',
  'ai-mate.chat-error.rate-limited-description': '您已達到要求的數量上限。請稍後再試一次。',
  'ai-mate.chat-error.rate-limited-title': '要求過多',
  'ai-mate.chat-error.rovo-inactive-description': '您的網站似乎並未啟用 Rovo。<link>設定 Rovo</link>',
  'ai-mate.chat-error.rovo-inactive-title': 'Rovo 處於非作用中的狀態',
  'ai-mate.chat-error.title': '我們不確定發生了什麼問題',
  'ai-mate.main-chat.close-chat-button-label': '關閉',
  'ai-mate.main-chat.maximize-chat-button-label': '全螢幕',
  'ai-mate.main-chat.minimize-chat-button-label': '復原檢視',
  'ai-mate.main-chat.new-chat-button-label': '新增',
  'ai-mate.main-chat.new-chat-button-label-full-screen': '新的聊天',
  'conversation-assistant-button.label': '聊天',
  'conversation-assistant-button.rovo-chat-label': 'Rovo Chat',
  'highlight-actions.rovo-chat-custom-prompt-submit-button.text': '傳送',
  'highlight-actions.rovo-chat-custom-prompt.placeholder': '向 AI 詢問',
  'highlight-actions.rovo-chat-explain-option.text': '說明',
  'highlight-actions.rovo-chat-explain-prompt':
    '藉由換個方式描述並且新增額外的細節來說明，但是請使用簡單的語言、簡短的句子，並且針對原始描述中所使用的專有名詞提供範例或定義。',
  'highlight-actions.rovo-chat-find-resources-option.text': '尋找資源',
  'highlight-actions.rovo-chat-find-resources-prompt': '在組織知識內，尋找僅支援所作陳述的資源。',
  'highlight-actions.rovo-chat-give-examples-option.text': '提供範例',
  'highlight-actions.rovo-chat-give-examples-prompt':
    '從組織資源或公開知識中提供相關例子。如果沒有可提供的資源，請嘗試提供比喻的例子，協助他人進一步了解。',
  'highlight-actions.rovo-chat-give-feedback-option.text': '提供意見反應',
  'highlight-actions.rovo-chat-give-feedback-prompt':
    '透過檢閱描述方式來提供意見反應。針對字詞的選擇、文法和標點符號提供看法。保持積極正面，但一律提供至少一項需要改善或變更的地方。',
  'highlight-actions.rovo-chat-more-options.tooltip': '聊天建議',
  'highlight-actions.rovo-chat-open-chat.tooltip': '開啟聊天',
  'highlight-actions.rovo-chat-summarize-option.text': '總結',
  'highlight-actions.rovo-chat-summarize-prompt':
    '凸顯其中的重點。專注於重要資訊並排除不必要的細節。在單一段落中提供簡潔的概述。',
  'highlight-actions.rovo-chat.button-text': '聊天',
  'highlight-actions.rovo-chat.button-text-ask-in-chat': '在聊天中詢問',
  'horizontal-scroll-container.scroll-left': '向左捲動',
  'horizontal-scroll-container.scroll-right': '向右捲動',
};
